/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

const navigationAnchor = document.getElementById("lang-button");
const body = document.querySelector("body");
if (navigationAnchor) {
	window.addEventListener("load", () => {
		navigationAnchor.addEventListener("click", function() {
			body.classList.toggle("lang-open");
		});
	});
}
